import React from "react";
import * as styles from "../styles/components/cookie-banner.module.css";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";
import { useEffect } from "react";
import { set } from "date-fns";

const CookierBanner = ({ setShowCookieBanner }) => {
  useEffect(() => {
    // Create a script element
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "//munchkin.marketo.net/munchkin.js";

    // Append the script to the head of the document
    document.head.appendChild(script);

    // Cleanup the script element when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  function initMunchkin() {
    if (window.Munchkin) {
      window.Munchkin.init("913-VOO-268");
    }
    setShowCookieBanner(false);
    localStorage.setItem("marketoCookie", "true");
  }

  function notAcceptCookie() {
    document.cookie = "mkto_opt_out=true; path=/; max-age=31536000";
    setShowCookieBanner(false);
    localStorage.setItem("marketoCookie", "true");
  }

  return (
    <div className={cn(styles.cookieWrapper, "color-palette-border-light")}>
      <div className={styles.flex}>
        <div className={cn(styles.subMenu)}>
          Our website uses cookies to improve your experience. It requires some
          cookies to function properly, while other cookies may be used for
          measurement and analytics.
          <div style={{ display: "inline-block" }}>
            <Link
              to={"/cookie-policy"}
              className="color-palette-color-underline"
            >
              &nbsp;{`Read our Cookie Policy.`}
            </Link>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => initMunchkin()}
            className={cn("btn color-palette-pseudo-bg", styles.button)}
          >
            Accept
          </button>
          <button
            onClick={() => notAcceptCookie()}
            className={cn(
              "btn secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke",
              styles.button
            )}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookierBanner;
